export const FileUploadItem = {
	key: "image",
	label: "CDN Dosyası",
	maxFileSize: "20971520",
	extensions: ["jpeg", "jpg", "png"],
	isRequired: true
};